module.exports = "<div [id]=\"fcId\"></div>\r\n"